import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import DataTableHelper from "../../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import AddUpdModal from './AddUpdModal'
import { getUsers, deleteUser, activeUsers } from '../../../helpers/backend_helper';
import { DestroyAlertHelper, Alert } from '../../../helpers/alerts/alertHelper';
import { getPolicyUser, getStorageUser } from '../../../helpers/api_helper';
import { Container } from "reactstrap";
import ButtonHelper from '../../../helpers/ButtonHelper';
import UpdatePassw from './updatePassw';

const Users = () => {
    const abortControllerRef = useRef();

    const authUser = getStorageUser();
    const policy = getPolicyUser();
    const [modalChangePassw, setModalChangePassw] = useState({ show: false, id: null });
    const [pending, setPending] = useState(false);
    const [modal, setModal] = useState({ show: false, update: false });
    const [dataPag, setDataPag] = useState({});
    const [filters, setFilters] = useState({ page: 1, perPage: 20, orderBy: 'id', order: 'asc', enter: false, search: '' });
    const [items, setItems] = useState([]);
    const [itemBase, setItemsBase] = useState(
        {
            id: 0,
            name: '',
            email: '',
            profile_id: null,
            phone: '',
            local_phone: '',
            profile: {
                id: 0,
                name: ''
            },
            route_id: authUser.route_id,
            route: authUser.route,
            company_id: authUser.company_id,
            phone_validated: 0,
        }
    );
    const [user, setUser] = useState(itemBase);

    useEffect(() => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        abortControllerRef.current = new AbortController();

        const getUsersRes = async () => {
            let params = {
                params: filters,
                signal: abortControllerRef.current.signal,
            }

            setPending(true)
            const response = await getUsers(params)
            setItems(response.data)
            setDataPag(response.meta)
            setPending(false)
        }
        getUsersRes()
    }, [filters])
    const addUpd = (row = false) => {
        if (row.id) {
            setUser(row)
            setModal({ ...modal, show: true, update: true })
        } else {
            setUser(itemBase)
            setModal({ ...modal, show: true, update: false })
        }
    }
    const destroy = async (id) => {
        await DestroyAlertHelper(async confirmed => {
            if (!confirmed) { return; }
            const response = await deleteUser(id);
            Alert(response.message, response.status)
            if (response.status) {
                setItems(
                    items.filter(i => i.id != id)
                );
            }
        });
    }

    const active = async (row) => {
        const response = await activeUsers(row);
        if (response.status) {
            let newItem = response.user;
            let array = items.map(item => item.id !== newItem.id ? item : newItem);
            setItems(array);
        }
    }

    const columns = Columns(addUpd, destroy, active, setModalChangePassw, authUser);
    document.title = "Users | Sistema de logística";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper tittle="Usuarios" columns={columns} items={items} pending={pending} config={dataPag} filters={filters} filterInp={true} setFilters={setFilters}>
                            <div className="col align-self-end">
                                <ButtonHelper
                                    addButon={policy.users.create ? true : false}
                                    actionAddButon={policy.users.create ? addUpd : false}
                                />
                            </div>
                        </DataTableHelper>
                    </div>
                </Container>
                {modal.show &&
                    <AddUpdModal
                        modal={modal}
                        setModal={setModal}
                        items={items}
                        setItems={setItems}
                        user={user}
                        setUser={setUser}
                    />
                }
                {modalChangePassw.show &&
                    <UpdatePassw
                        modal={modalChangePassw}
                        setModal={setModalChangePassw}
                    />
                }
            </div>
        </React.Fragment>
    );
};

export default Users;